export default __webpack_public_path__ + "static/media/1841.8b550c99.png";